/*
--------------------------------------------------------

 Index

--------------------------------------------------------
*/


// 読みもの　一覧　アーカイブ（PC） リスト表示
$(function() {
	$('#dev-select-date-pc').selectric();
  });

// 読みもの　一覧　アーカイブ（PC） リンク
const selected = $("select[name=search_date]");
    selected.on('change', function(){
        window.location.href = selected.val();
    });


// 読みもの　一覧　アーカイブ（SP） リスト表示
$(function(){
	//.selectMenu_filtersの中の.selectMenu_filters_ttlがクリックされたら
	$('.selectMenu_filters .selectMenu_filters_ttl').click(function(){
	  //クリックされた.selectMenu_filtersの中の.selectMenu_filters_ttlに隣接する.selectMenu_filters_dataが開いたり閉じたりする。
	  $(this).next('.selectMenu_filters_data').slideToggle();
	  $(this).toggleClass("open");
	});
  });






